// import React, { useState } from "react";
// import Field from "./Field";
// import useStyles from "./styles";
// import styles from "./adminLogin.module.css";
// import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
// import jwtDecode from "jwt-decode";
// import { useDispatch } from "react-redux";
// import { useHistory, Link } from "react-router-dom";
// import { signup, signin, adminSignin, adminSignup } from "../../actions/auth";
// import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

// import {
//   Avatar,
//   Button,
//   Paper,
//   Grid,
//   Typography,
//   Container,
// } from "@material-ui/core";
// import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
// import { createProfile } from "../../actions/profile";
// import { useSnackbar } from "react-simple-snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { adminSignIn } from "../../api";

// const initialState = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   password: "",
//   confirmPassword: "",
//   profilePicture: "",
//   bio: "",
//   userType:""
// };

// const AdminLogin = () => {
//   const classes = useStyles();
//   const [formData, setFormData] = useState(initialState);
//   const [isSignup, setIsSignup] = useState(false);
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [showPassword, setShowPassword] = useState(false);
//   // eslint-disable-next-line
//   const [openSnackbar, closeSnackbar] = useSnackbar();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const [loading, setLoading] = useState(false);

//   const handleShowPassword = () => setShowPassword(!showPassword);
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//       dispatch(adminSignup(formData, openSnackbar, setLoading));

//     setLoading(true);
//   };

//   const switchMode = () => {
//     setIsSignup((prevState) => !prevState);
//   };

//   // const googleSuccess = async (res) => {
//   //     const result = jwtDecode(res.credential);
//   //     const token = res?.credential;
//   //     dispatch(createProfile({name: result?.name, email: result?.email, userId: result?.jti, phoneNumber: '', businessName: '', contactAddress: '', logo: result?.picture, website: ''}))

//   //     try {
//   //         dispatch({ type: "AUTH", data: {result, token}})

//   //         window.location.href='/adminDashboard'

//   //     } catch (error) {
//   //         console.log(error)
//   //     }
//   // }
//   // const googleError =(error) => {
//   //     console.log(error)
//   //     console.log("Google Sign In was unseccassful. Try again later")
//   // }

//   // if (user) {
//   //   history.push("/adminDashboard");
//   // }

//   return (
//     <>
//       <Container component="main" maxWidth="xs">

//         <Paper className={classes.paper} elevation={2}>
//           {/* <Avatar className={classes.avatar}>
//             <LockOutlinedIcon />
//           </Avatar> */}
//           {/* <Typography component="h1" variant="h5">
//              Add User Details
//           </Typography> */}
//           <form className={classes.form} onSubmit={handleSubmit}>
//             <Grid container spacing={2}>

//                 <>
//                   <Field
//                     name="firstName"
//                     label="First Name"
//                     handleChange={handleChange}
//                     autoFocus
//                     half
//                   />
//                   <Field
//                     name="lastName"
//                     label="Last Name"
//                     handleChange={handleChange}
//                     half
//                   />
//                 </>

//               <Field
//                 name="email"
//                 label="Email Address"
//                 handleChange={handleChange}
//                 type="email"
//               />
//               <Field
//                 name="password"
//                 label="Password"
//                 handleChange={handleChange}
//                 type={showPassword ? "text" : "password"}
//                 handleShowPassword={handleShowPassword}
//               />

//                 <Field
//                   name="confirmPassword"
//                   label="Repeat Password"
//                   handleChange={handleChange}
//                   type="password"
//                 />

//                 <FormControl className={classes.formControl}>
//                   <InputLabel id="userType-label">User Type</InputLabel>
//                   <Select
//                     labelId="userType-label"
//                     id="userType"
//                     name="userType"
//                     onChange={handleChange}
//                   >
//                     <MenuItem value="user">Salesperson</MenuItem>
//                     <MenuItem value="admin">Admin</MenuItem>
//                   </Select>
//                 </FormControl>

//             </Grid>
//             <div className={styles.buttons}>
//               <div>
//                 {/* <button className={styles.submitBtn}> { isSignup ? 'Sign Up' : 'Sign In' }</button> */}
//                 {/* <ProgressButton>{ isSignup ? 'Sign Up' : 'Sign In' }</ProgressButton> */}
//                 {loading ? (
//                   <CircularProgress />
//                 ) : (
//                   <button className={styles.loginBtn}>
//                      Sign Up
//                   </button>
//                 )}
//               </div>
//               {/* <div className={styles.option}>
//                   <span>or</span>
//                 </div>
//                 <div>
//                   <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
//                     <GoogleLogin
//                       onSuccess={googleSuccess}
//                       onError={googleError}
//                       text='continue_with'
//                       useOneTap
//                       auto_select
//                       state_cookie_domain='single_host_origin'
//                     />
//                   </GoogleOAuthProvider>
//                 </div> */}
//             </div>

//             {/* <Link to="forgot">
//               <p
//                 style={{
//                   textAlign: "center",
//                   color: "#1d7dd6",
//                   marginTop: "20px",
//                 }}
//               >
//                 Forgotten Password?
//               </p>
//             </Link> */}
//           </form>
//         </Paper>
//       </Container>
//     </>
//   );
// };

// export default AdminLogin;
//---------------------------------------------

// import React, { useState } from "react";
// import Field from "./Field";
// import useStyles from "./styles";
// import styles from "./adminLogin.module.css";
// import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
// import jwtDecode from "jwt-decode";
// import { useDispatch } from "react-redux";
// import { useHistory, Link } from "react-router-dom";
// import { signup, signin, adminSignin, adminSignup } from "../../actions/auth";
// import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
// import {
//   Avatar,
//   Button,
//   Paper,
//   Grid,
//   Typography,
//   Container,
//   Checkbox,
//   FormControlLabel,
// } from "@material-ui/core";
// import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
// import { createProfile } from "../../actions/profile";
// import { useSnackbar } from "react-simple-snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { adminSignIn } from "../../api";

// const initialState = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   password: "",
//   confirmPassword: "",
//   profilePicture: "",
//   bio: "",
//   userType: "",
//   permissions: {
//     canDelete: false,
//     canEdit: false,
//   },
// };

// const AdminLogin = ({ initialData, onSubmit }) => {
//   const classes = useStyles();
//   const [formData, setFormData] = useState(initialData || initialState);
//   const [isSignup, setIsSignup] = useState(false);
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const [loading, setLoading] = useState(false);

//   const handleShowPassword = () => setShowPassword(!showPassword);

//   const handleChange = (e) => {
//     if (e.target.name.startsWith("permissions.")) {
//       const permission = e.target.name.split(".")[1];
//       setFormData({
//         ...formData,
//         permissions: {
//           ...formData.permissions,
//           [permission]: e.target.checked,
//         },
//       });
//     } else {
//       setFormData({ ...formData, [e.target.name]: e.target.value });
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     // Step 1: Added console.log to debug formData
//     console.log("Form Data Sent to Backend:", formData);
//     if (onSubmit) {
//       onSubmit(formData);
//     } else {
//       dispatch(adminSignup(formData, openSnackbar, setLoading));
//     }
//   };

//   const switchMode = () => {
//     setIsSignup((prevState) => !prevState);
//   };

//   // (Commented-out Google login code preserved)
//   // const googleSuccess = async (res) => { ... }
//   // const googleError = (error) => { ... }
//   // if (user) { history.push("/adminDashboard"); }

//   return (
//     <>
//       <Container component="main" maxWidth="xs">
//         <Paper className={classes.paper} elevation={2}>
//           <form className={classes.form} onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               <>
//                 <Field
//                   name="firstName"
//                   label="First Name"
//                   handleChange={handleChange}
//                   autoFocus
//                   half
//                   value={formData.firstName}
//                 />
//                 <Field
//                   name="lastName"
//                   label="Last Name"
//                   handleChange={handleChange}
//                   half
//                   value={formData.lastName}
//                 />
//               </>
//               <Field
//                 name="email"
//                 label="Email Address"
//                 handleChange={handleChange}
//                 type="email"
//                 value={formData.email}
//               />
//               <Field
//                 name="password"
//                 label="Password"
//                 handleChange={handleChange}
//                 type={showPassword ? "text" : "password"}
//                 handleShowPassword={handleShowPassword}
//                 value={formData.password}
//               />
//               <Field
//                 name="confirmPassword"
//                 label="Repeat Password"
//                 handleChange={handleChange}
//                 type="password"
//                 value={formData.confirmPassword}
//               />
//               <FormControl className={classes.formControl}>
//                 <InputLabel id="userType-label">User Type</InputLabel>
//                 <Select
//                   labelId="userType-label"
//                   id="userType"
//                   name="userType"
//                   onChange={handleChange}
//                   value={formData.userType}
//                 >
//                   <MenuItem value="user">User</MenuItem>
//                   <MenuItem value="admin">Admin</MenuItem>
//                 </Select>
//               </FormControl>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1">Permissions</Typography>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={formData.permissions.canDelete}
//                       onChange={handleChange}
//                       name="permissions.canDelete"
//                     />
//                   }
//                   label="Can Delete"
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={formData.permissions.canEdit}
//                       onChange={handleChange}
//                       name="permissions.canEdit"
//                     />
//                   }
//                   label="Can Edit"
//                 />
//               </Grid>
//             </Grid>
//             <div className={styles.buttons}>
//               <div>
//                 {loading ? (
//                   <CircularProgress />
//                 ) : (
//                   <button className={styles.loginBtn}>Sign Up</button>
//                 )}
//               </div>
//             </div>
//           </form>
//         </Paper>
//       </Container>
//     </>
//   );
// };

// export default AdminLogin;

//--------------------------------------------------

// import React, { useState } from "react";
// import Field from "./Field";
// import useStyles from "./styles";
// import styles from "./adminLogin.module.css";
// import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
// import jwtDecode from "jwt-decode";
// import { useDispatch } from "react-redux";
// import { useHistory, Link } from "react-router-dom";
// import { signup, signin, adminSignin, adminSignup } from "../../actions/auth";
// import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
// import {
//   Button,
//   Paper,
//   Grid,
//   Typography,
//   Checkbox,
//   FormControlLabel,
// } from "@material-ui/core";
// import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
// import { createProfile } from "../../actions/profile";
// import { useSnackbar } from "react-simple-snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { adminSignIn } from "../../api";
// import { makeStyles } from "@material-ui/core/styles";

// const useCustomStyles = makeStyles((theme) => ({
//   paper: {
//     width: "100%",
//     maxWidth: "380px", // Compact width for dialog
//     borderRadius: "8px",
//     boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
//     backgroundColor: "#ffffff",
//     overflow: "hidden",
//   },
//   header: {
//     backgroundColor: "#f5f5f5",
//     padding: theme.spacing(1.5),
//     textAlign: "center",
//     borderBottom: "1px solid #e0e0e0",
//     position: "sticky",
//     top: 0,
//     zIndex: 1,
//   },
//   title: {
//     fontSize: "1.2rem",
//     fontWeight: 500,
//     color: "#333",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: theme.spacing(1),
//   },
//   form: {
//     padding: "5px 10px 40px 10px !important",
//     maxHeight: "55vh", // Compact height for dialog
//     overflowY: "auto", // Scroll if needed
//   },
//   field: {
//     marginBottom: theme.spacing(1.5),
//     "& .MuiInputBase-root": {
//       borderRadius: "6px",
//       backgroundColor: "#f9f9f9",
//     },
//   },
//   formControl: {
//     margin: theme.spacing(1.5, 0),
//     width: "100%",
//     "& .MuiInputBase-root": {
//       borderRadius: "6px",
//       backgroundColor: "#f9f9f9",
//     },
//   },
//   permissionsSection: {
//     padding: theme.spacing(1),
//     backgroundColor: "#f0f0f0",
//     borderRadius: "6px",
//     marginTop: theme.spacing(1),
//   },
//   submitButton: {
//     marginTop: theme.spacing(2),
//     padding: theme.spacing(1),
//     background: "linear-gradient(45deg, #ef7f1a 30%, #ff9800 90%)",
//     color: "#fff",
//     borderRadius: "6px",
//     "&:hover": {
//       background: "linear-gradient(45deg, #d96f17 30%, #e68a00 90%)",
//     },
//   },
//   loadingContainer: {
//     display: "flex",
//     justifyContent: "center",
//     marginTop: theme.spacing(2),
//   },
// }));

// const initialState = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   password: "",
//   confirmPassword: "",
//   profilePicture: "",
//   bio: "",
//   userType: "",
//   permissions: {
//     canDelete: false,
//     canEdit: false,
//   },
// };

// const AdminLogin = ({ initialData, onSubmit }) => {
//   const classes = useStyles();
//   const customClasses = useCustomStyles();
//   const [formData, setFormData] = useState(initialData || initialState);
//   const [isSignup, setIsSignup] = useState(false);
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const [loading, setLoading] = useState(false);

//   const handleShowPassword = () => setShowPassword(!showPassword);

//   const handleChange = (e) => {
//     if (e.target.name.startsWith("permissions.")) {
//       const permission = e.target.name.split(".")[1];
//       setFormData({
//         ...formData,
//         permissions: {
//           ...formData.permissions,
//           [permission]: e.target.checked,
//         },
//       });
//     } else {
//       setFormData({ ...formData, [e.target.name]: e.target.value });
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     console.log("Form Data Sent to Backend:", formData);
//     if (onSubmit) {
//       onSubmit(formData);
//     } else {
//       dispatch(adminSignup(formData, openSnackbar, setLoading));
//     }
//   };

//   const switchMode = () => {
//     setIsSignup((prevState) => !prevState);
//   };

//   return (
//     <Paper className={customClasses.paper} elevation={2}>
//       <div className={customClasses.header}>
//         <Typography className={customClasses.title}>
//           <LockOutlinedIcon style={{ color: "#ef7f1a" }} />
//           Create New User
//         </Typography>
//       </div>
//       <form className={customClasses.form} onSubmit={handleSubmit}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <Field
//               name="firstName"
//               label="First Name"
//               handleChange={handleChange}
//               autoFocus
//               value={formData.firstName}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="lastName"
//               label="Last Name"
//               handleChange={handleChange}
//               value={formData.lastName}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="email"
//               label="Email Address"
//               handleChange={handleChange}
//               type="email"
//               value={formData.email}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="password"
//               label="Password"
//               handleChange={handleChange}
//               type={showPassword ? "text" : "password"}
//               handleShowPassword={handleShowPassword}
//               value={formData.password}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="confirmPassword"
//               label="Repeat Password"
//               handleChange={handleChange}
//               type="password"
//               value={formData.confirmPassword}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <FormControl className={customClasses.formControl}>
//               <InputLabel id="userType-label">User Type</InputLabel>
//               <Select
//                 labelId="userType-label"
//                 id="userType"
//                 name="userType"
//                 onChange={handleChange}
//                 value={formData.userType}
//               >
//                 <MenuItem value="user">User</MenuItem>
//                 <MenuItem value="admin">Admin</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} className={customClasses.permissionsSection}>
//             <Typography variant="subtitle2">Permissions</Typography>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.permissions.canDelete}
//                   onChange={handleChange}
//                   name="permissions.canDelete"
//                   color="primary"
//                 />
//               }
//               label="Can Delete"
//             />
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.permissions.canEdit}
//                   onChange={handleChange}
//                   name="permissions.canEdit"
//                   color="primary"
//                 />
//               }
//               label="Can Edit"
//             />
//           </Grid>
//         </Grid>
//         {loading ? (
//           <div className={customClasses.loadingContainer}>
//             <CircularProgress />
//           </div>
//         ) : (
//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             className={customClasses.submitButton}
//           >
//             Sign Up
//           </Button>
//         )}
//       </form>
//     </Paper>
//   );
// };

// export default AdminLogin;

//----------------------------------------------------------------
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import Field from "./Field"; // Ensure this file exists
// import useStyles from "./styles"; // Ensure this file exists
// import styles from "./adminLogin.module.css"; // Ensure this file exists
// import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
// import jwtDecode from "jwt-decode";
// import { useDispatch } from "react-redux";
// import { useHistory, Link } from "react-router-dom";
// import { signup, signin, adminSignin, adminSignup } from "../../actions/auth";
// import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
// import {
//   Button,
//   Paper,
//   Grid,
//   Typography,
//   Checkbox,
//   FormControlLabel,
// } from "@material-ui/core";
// import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
// import { createProfile } from "../../actions/profile"; // Ensure this action exists
// import { useSnackbar } from "react-simple-snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { adminSignIn } from "../../api"; // Ensure this API call exists
// import { makeStyles } from "@material-ui/core/styles";

// const useCustomStyles = makeStyles((theme) => ({
//   paper: {
//     width: "100%",
//     maxWidth: "380px",
//     borderRadius: "8px",
//     boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
//     backgroundColor: "#ffffff",
//     overflow: "hidden",
//   },
//   header: {
//     backgroundColor: "#f5f5f5",
//     padding: theme.spacing(1.5),
//     textAlign: "center",
//     borderBottom: "1px solid #e0e0e0",
//     position: "sticky",
//     top: 0,
//     zIndex: 1,
//   },
//   title: {
//     fontSize: "1.2rem",
//     fontWeight: 500,
//     color: "#333",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: theme.spacing(1),
//   },
//   form: {
//     padding: "4px 10px 40px 10px !important",
//     maxHeight: "55vh",
//     overflowY: "auto",
//   },
//   field: {
//     marginBottom: theme.spacing(1.5),
//     "& .MuiInputBase-root": {
//       borderRadius: "6px",
//       backgroundColor: "#f9f9f9",
//     },
//   },
//   formControl: {
//     margin: theme.spacing(1.5, 0),
//     width: "100%",
//     "& .MuiInputBase-root": {
//       borderRadius: "6px",
//       backgroundColor: "#f9f9f9",
//     },
//   },
//   submitButton: {
//     marginTop: theme.spacing(2),
//     padding: theme.spacing(1),
//     background: "linear-gradient(45deg, #ef7f1a 30%, #ff9800 90%)",
//     color: "#fff",
//     borderRadius: "6px",
//     "&:hover": {
//       background: "linear-gradient(45deg, #d96f17 30%, #e68a00 90%)",
//     },
//   },
//   loadingContainer: {
//     display: "flex",
//     justifyContent: "center",
//     marginTop: theme.spacing(2),
//   },
// }));

// const initialState = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   password: "",
//   confirmPassword: "",
//   profilePicture: "",
//   bio: "",
//   userType: [],
// };

// const AdminLogin = ({ userTypes, initialData, onSubmit }) => {
//   const classes = useStyles();
//   const customClasses = useCustomStyles();
//   const [formData, setFormData] = useState(initialData || initialState);
//   const [isSignup, setIsSignup] = useState(false);
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const [loading, setLoading] = useState(false);

//   const handleShowPassword = () => setShowPassword(!showPassword);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     console.log("Form Data Sent to Backend:", formData);
//     if (onSubmit) {
//       onSubmit(formData);
//     } else {
//       dispatch(adminSignup(formData, openSnackbar, setLoading));
//     }
//   };

//   const switchMode = () => {
//     setIsSignup((prevState) => !prevState);
//   };

//   return (
//     <Paper className={customClasses.paper} elevation={2}>
//       <div className={customClasses.header}>
//         <Typography className={customClasses.title}>
//           <LockOutlinedIcon style={{ color: "#ef7f1a" }} />
//           Create New User
//         </Typography>
//       </div>
//       <form className={customClasses.form} onSubmit={handleSubmit}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <Field
//               name="firstName"
//               label="First Name"
//               handleChange={handleChange}
//               autoFocus
//               value={formData.firstName}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="lastName"
//               label="Last Name"
//               handleChange={handleChange}
//               value={formData.lastName}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="email"
//               label="Email Address"
//               handleChange={handleChange}
//               type="email"
//               value={formData.email}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="password"
//               label="Password"
//               handleChange={handleChange}
//               type={showPassword ? "text" : "password"}
//               handleShowPassword={handleShowPassword}
//               value={formData.password}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Field
//               name="confirmPassword"
//               label="Repeat Password"
//               handleChange={handleChange}
//               type="password"
//               value={formData.confirmPassword}
//               className={customClasses.field}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <FormControl className={customClasses.formControl}>
//               <InputLabel id="userType-label">User Type</InputLabel>
//               <Select
//                 labelId="userType-label"
//                 id="userType"
//                 name="userType"
//                 value={formData.userType || ""} // Single value instead of array
//                 onChange={handleChange}
//                 renderValue={(selected) => selected} // Display the single selected value
//               >
//                 {userTypes && userTypes.length > 0 ? (
//                   userTypes.map((ut) => (
//                     <MenuItem
//                       key={ut.name}
//                       value={ut.name}
//                       disabled={!ut.active}
//                     >
//                       {ut.name} {ut.active ? "" : "(Inactive)"}
//                     </MenuItem>
//                   ))
//                 ) : (
//                   <MenuItem disabled>No user types available</MenuItem>
//                 )}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//         {loading ? (
//           <div className={customClasses.loadingContainer}>
//             <CircularProgress />
//           </div>
//         ) : (
//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             className={customClasses.submitButton}
//           >
//             Sign Up
//           </Button>
//         )}
//       </form>
//     </Paper>
//   );
// };

// export default AdminLogin;


//--------------------


import React, { useState } from "react";
import { useSelector } from "react-redux";
import Field from "./Field"; // Ensure this file exists
import useStyles from "./styles"; // Ensure this file exists
import styles from "./adminLogin.module.css"; // Ensure this file exists
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { adminSignup } from "../../actions/auth";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import {
  Button,
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useSnackbar } from "react-simple-snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useCustomStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    maxWidth: "380px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    backgroundColor: "#ffffff",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(1.5),
    textAlign: "center",
    borderBottom: "1px solid #e0e0e0",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: 500,
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  form: {
    padding: "4px 10px 40px 10px !important",
    maxHeight: "55vh",
    overflowY: "auto",
  },
  field: {
    marginBottom: theme.spacing(1.5),
    "& .MuiInputBase-root": {
      borderRadius: "6px",
      backgroundColor: "#f9f9f9",
    },
  },
  formControl: {
    margin: theme.spacing(1.5, 0),
    width: "100%",
    "& .MuiInputBase-root": {
      borderRadius: "6px",
      backgroundColor: "#f9f9f9",
    },
  },
  submitButton: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    background: "linear-gradient(45deg, #ef7f1a 30%, #ff9800 90%)",
    color: "#fff",
    borderRadius: "6px",
    "&:hover": {
      background: "linear-gradient(45deg, #d96f17 30%, #e68a00 90%)",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  profilePicture: "",
  bio: "",
  userType: "", // Single string
};

const AdminLogin = ({ userTypes, initialData, onSubmit, onClose }) => {
  const classes = useStyles();
  const customClasses = useCustomStyles();
  const [formData, setFormData] = useState(initialData || initialState);
  const [isSignup, setIsSignup] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [openSnackbar] = useSnackbar();
  const user = JSON.parse(localStorage.getItem("profile"));
  const [loading, setLoading] = useState(false);

  const handleShowPassword = () => setShowPassword(!showPassword);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Form Data Sent to Backend:", formData);
    
    if (onSubmit) {
      onSubmit(formData);
    } else {
      dispatch(adminSignup(formData, openSnackbar, setLoading, () => {
        openSnackbar("User created successfully");
        if (onClose) onClose();
        window.location.reload();
      }));
    }
  };

  const switchMode = () => {
    setIsSignup((prevState) => !prevState);
  };

  return (
    <Paper className={customClasses.paper} elevation={2}>
      <div className={customClasses.header}>
        <Typography className={customClasses.title}>
          <LockOutlinedIcon style={{ color: "#ef7f1a" }} />
          Create New User
        </Typography>
      </div>
      <form className={customClasses.form} onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Field
              name="firstName"
              label="First Name"
              handleChange={handleChange}
              autoFocus
              value={formData.firstName}
              className={customClasses.field}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="lastName"
              label="Last Name"
              handleChange={handleChange}
              value={formData.lastName}
              className={customClasses.field}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="email"
              label="Email Address"
              handleChange={handleChange}
              type="email"
              value={formData.email}
              className={customClasses.field}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="password"
              label="Password"
              handleChange={handleChange}
              type={showPassword ? "text" : "password"}
              handleShowPassword={handleShowPassword}
              value={formData.password}
              className={customClasses.field}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="confirmPassword"
              label="Repeat Password"
              handleChange={handleChange}
              type="password"
              value={formData.confirmPassword}
              className={customClasses.field}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl className={customClasses.formControl}>
              <Select
                labelId="userType-label"
                id="userType"
                name="userType"
                value={formData.userType || ""}
                onChange={handleChange}
                displayEmpty // Ensures placeholder is shown when value is empty
                renderValue={(selected) => selected || "User Type"} // Placeholder inside dropdown
              >
                <MenuItem value="" disabled>
                  User Type
                </MenuItem>
                {userTypes && userTypes.length > 0 ? (
                  userTypes.map((ut) => (
                    <MenuItem key={ut.name} value={ut.name} disabled={!ut.active}>
                      {ut.name} {ut.active ? "" : "(Inactive)"}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No user types available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {loading ? (
          <div className={customClasses.loadingContainer}>
            <CircularProgress />
          </div>
        ) : (
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={customClasses.submitButton}
          >
            Sign Up
          </Button>
        )}
      </form>
    </Paper>
  );
};

export default AdminLogin;